// Mirrors src/components/common/Avatar.tsx — circular with initials fallback,
// surfaceLight bg, surfaceBorder ring, ~35% font-size scaling.

import React from 'react'
import clsx from 'clsx'

interface AvatarProps {
  uri?: string | null
  name: string
  size?: number
  className?: string
}

export const Avatar: React.FC<AvatarProps> = ({uri, name, size = 44, className}) => {
  const initials = name
    .split(' ')
    .map(w => w[0])
    .join('')
    .substring(0, 2)
    .toUpperCase()

  const style = {width: size, height: size}
  const fontSize = Math.round(size * 0.35)

  if (uri) {
    return (
      <img
        src={uri}
        alt={name}
        style={style}
        className={clsx('rounded-full object-cover', className)}
      />
    )
  }

  return (
    <div
      style={style}
      className={clsx(
        'flex items-center justify-center rounded-full bg-surfaceLight',
        'border border-surfaceBorder',
        className,
      )}
    >
      <span
        className="font-semibold text-textSecondary"
        style={{fontSize}}
      >
        {initials}
      </span>
    </div>
  )
}
